export interface RouteConfig {
  [key: string]: NestedRoute;
}

export interface NestedRoute {
  path: string;
  label?: string;
  getPath?: (...args: string[]) => string;
  [key: string]: any;
}

export const AdminRoutes: RouteConfig = {
  auth: {
    path: '/auth',
    label: 'Авторизация',
    esia: {
      path: '/auth/esia',
      backPath: '/auth',
      label: 'Вход через ЕСИА',
    },
    ecp: {
      path: '/auth/ecp',
      backPath: '/auth',
      label: 'Вход с КЭП',
    },
    blocked: {
      path: '/auth/blocked',
      label: 'Вход временно заблокирован',
    },
    unavailable: {
      path: '/auth/unavailable',
      label: 'Вход недоступен',
    },
    esiaErrors: {
      path: '/auth/esia-errors',
      label: 'Ошибки ЕСИА',
    },
    authError: {
      path: '/auth/error',
      label: 'Ошибка авторизации',
    },
  },

  users: {
    path: '/users',
    label: 'Клиенты',
    pending: {
      path: '/users/pending',
      label: 'Ожидающие подтверждения',
    },
    list: {
      path: '/users',
      label: 'Все клиенты',
    },
    detail: {
      path: '/users/:id',
      getPath: (id: string) => `/users/${id}`,
      label: 'Детали клиента',
    },
  },

  organizations: {
    path: '/organizations',
    label: 'Организации',
    pending: {
      path: '/organizations/pending',
      label: 'Ожидающие подтверждения',
    },
    list: {
      path: '/organizations',
      label: 'Все организации',
    },
    detail: {
      path: '/organizations/:id',
      getPath: (id: string) => `/organizations/${id}`,
      label: 'Детали организации',
    },
  },

  applications: {
    path: '/applications',
    label: 'Заявки',
    list: {
      path: '/applications',
      label: 'Все заявки',
    },
    detail: {
      path: '/applications/:id',
      getPath: (id: string) => `/applications/${id}`,
      label: 'Детали заявки',
    },
    pending: {
      path: '/applications/pending',
      label: 'Ожидающие рассмотрения',
    },
  },

  reports: {
    path: '/reports',
    label: 'Отчеты',
    analytics: {
      path: '/reports/analytics',
      label: 'Аналитика',
    },
    statistics: {
      path: '/reports/statistics',
      label: 'Статистика',
    },
  },

  settings: {
    path: '/settings',
    label: 'Настройки',
    system: {
      path: '/settings/system',
      label: 'Системные настройки',
    },
    users: {
      path: '/settings/users',
      label: 'Управление пользователями',
    },
  },

  dashboard: {
    path: '/',
    label: 'Главная',
  },

  root: { path: '/' },
};
